
const UserStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  PENDING_UNPAUSE: 'PENDING_UNPAUSE',
  UNDEFINED: 'UNDEFINED',
});

export default UserStatus;